import Vue from 'vue';
import Helpers from './helpers';
import Config from './config';

Vue.use(Helpers);
Vue.use(Config);
